import React, { useState } from 'react';
import { useAppContext } from '../../../hooks/AppContext';
import { RadioTile, TileGroup } from 'carbon-components-react';
import { prop } from 'ramda';
import { getQuestion } from 'src/apps/envizi-price-estimator/utility';
import { segmentTracking } from '../../../lib/tracker';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import { FormattedMessage, useIntl } from 'react-intl';
import { stepProps } from './Step1';
import { AnswerData } from 'src/apps/envizi-price-estimator/types';

const Step4 = ({ isOpen, question }: stepProps) => {
  const { appState, appAction } = useAppContext();
  const [complianceOption, setComplianceOption] = useState('');
  const [insightOption, setInsightOption] = useState('');
  const otherSubQue = getQuestion(appState, 'Q6');

  const submitted = prop('submitted')(appState);
  const submittedComplianceId = submitted && submitted[question.id];
  const submittedCompAnsValue =
    submittedComplianceId && Object.values(submittedComplianceId)[0];

  const submittedInsightAnsId = submitted && submitted[otherSubQue.id];
  const submittedInsightAnsValue =
    submittedInsightAnsId && Object.values(submittedInsightAnsId)[0];
  const intl = useIntl();

  const handleCompliance = (id: string, value: string) => {
    const translatedValue =
      value === 'Yes'
        ? intl.formatMessage(messages.yes)
        : intl.formatMessage(messages.no);
    setComplianceOption(translatedValue);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Compliance radio input',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'answerSingle',
      answerId: id,
      answerValue: `${translatedValue} Cookie-${value}`,
    });
  };

  const handleInsight = (id: string, value: string) => {
    const translatedValue =
      value === 'Yes'
        ? intl.formatMessage(messages.yes)
        : intl.formatMessage(messages.no);
    setInsightOption(translatedValue);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Insight radio input',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'answerSingle',
      answerId: id,
      answerValue: `${translatedValue} Cookie-${value}`,
    });
  };

  return isOpen ? (
    <div>
      <div className="page_sub_heading">
        <FormattedMessage {...messages.scope3_title} />
      </div>
      <hr className="thin" />
      <br />
      <p>
        <FormattedMessage {...messages.sub_que_3a} />
      </p>
      <div className="page_sub_heading padding_8">
        <FormattedMessage {...messages.scope3_que1_title} />
      </div>
      <p>
        <FormattedMessage {...messages.scope3_que1_desc} />
      </p>
      <TileGroup
        name="radio-group-compliance"
        className="tilegroup"
        valueSelected={
          submittedCompAnsValue
            ? submittedCompAnsValue.split(' ')[0]
            : complianceOption
        }
      >
        {question?.answers?.map((item: AnswerData) => (
          <RadioTile
            key={item.id}
            className="tile"
            id={`radio-compliance-${item.text}`}
            value={
              item.text === 'Yes'
                ? intl.formatMessage(messages.yes)
                : intl.formatMessage(messages.no)
            }
            onClick={() => handleCompliance(item.id, item.text)}
          >
            {item.text === 'Yes' ? (
              <FormattedMessage {...messages.yes} />
            ) : (
              <FormattedMessage {...messages.no} />
            )}
          </RadioTile>
        ))}
      </TileGroup>
      <br />
      <p>
        <FormattedMessage {...messages.sub_que_3b} />
      </p>
      <div className="page_sub_heading padding_8">
        <FormattedMessage {...messages.scope3_que2_title} />
      </div>
      <p>
        <FormattedMessage {...messages.scope3_que2_desc} />
      </p>
      <TileGroup
        name="radio-group-insight"
        className="tilegroup"
        valueSelected={
          submittedInsightAnsValue
            ? submittedInsightAnsValue.split(' ')[0]
            : insightOption
        }
      >
        {otherSubQue?.answers?.map((item: AnswerData) => (
          <RadioTile
            key={item.id}
            className="tile"
            id={`radio-insight-${item.text}`}
            value={
              item.text === 'Yes'
                ? intl.formatMessage(messages.yes)
                : intl.formatMessage(messages.no)
            }
            onClick={() => handleInsight(item.id, item.text)}
          >
            {item.text === 'Yes' ? (
              <FormattedMessage {...messages.yes} />
            ) : (
              <FormattedMessage {...messages.no} />
            )}
          </RadioTile>
        ))}
      </TileGroup>
    </div>
  ) : null;
};

export default Step4;
